import React, {Component} from 'react';
import {AppConsumer} from '../components/AppContext';
import withTracker from "../utils/withTracker";

const SCHEME = 'numia';
const HOST   = 'screenshare';


function buildStartDeeplink(bundle) {
    const { MeetingId, ExternalUserId, Attendee, MediaPlacement } = bundle;
    const qs = new URLSearchParams({
        meetingId: MeetingId,
        attendeeId: Attendee.AttendeeId,
        externalUserId: ExternalUserId || Attendee.AttendeeId,
        joinToken: Attendee.JoinToken,
        audioFallbackUrl: MediaPlacement.AudioFallbackUrl,
        audioHostUrl: MediaPlacement.AudioHostUrl,
        signalingUrl: MediaPlacement.SignalingUrl,
        turnControlUrl: MediaPlacement.TurnControlUrl,
        ingestionUrl: MediaPlacement.EventIngestionUrl || ''
    }).toString();
    return `${SCHEME}://${HOST}/start?${qs}`;
}

function buildStopDeeplink() {
    return `${SCHEME}://${HOST}/stop`;
}

function fetchContentShareBundle(meetingId, companyName) {
    return fetch('/api/v2/awsvideocall/content-share-attendee/' + encodeURIComponent(companyName) + '?meetingId=' + encodeURIComponent(meetingId),
        { method: 'GET', credentials: 'include' }
    ).then(function (r) {
        if (!r.ok) throw new Error('endpoint content-share-attendee falló');
        return r.json();
    });
}

class Videocall extends Component {
    constructor(props) {
        super(props);
        this.state = { videocallEnded: false,pendingIntent: null, userStartedCall: false, isScreenSharing: false };
        this.iframeMessageListener = this.iframeMessageListener.bind(this);
        this.focusVideocall = false;
        this.number = 0;
        this._openTimer = null;
        this._hadVisibilityChange = false;
    }

    startVideocall = () => {
        this.setState({ userStartedCall: true });
    };

    isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    tryOpenDeeplink(url) {
        if (!this.isMobileDevice()) {
            return;
        }

        const onVis = () => { this._hadVisibilityChange = true; };
        document.addEventListener('visibilitychange', onVis, { once: true });
        window.top.location.href = url;
        clearTimeout(this._openTimer);
        this._openTimer = setTimeout(() => {
            document.removeEventListener('visibilitychange', onVis);
            if (!this._hadVisibilityChange) {
                console.warn('[HOST] No hay app para manejar el deeplink:', url);
            }
            this._hadVisibilityChange = false;
        }, 1200);
    }

    stopScreenshare() {
        if (!this.state.isScreenSharing) {
            return;
        }
        this.tryOpenDeeplink(buildStopDeeplink());
        this.setState({ isScreenSharing: false });
    }

    goHome() {
        this.context.actions.goToSearchCodeView();
    }

    sendReattachMessage = (data) => {
        const initDataForVideocall = {};
        initDataForVideocall.event = "reattach";
        if (data) {
            initDataForVideocall.yourusername = data.yourusername
            initDataForVideocall.myusername = data.myusername
            initDataForVideocall.turnId = data.turnId
        }

        if (this.iframe) {
            document.getElementsByTagName("iframe")[0].contentWindow.postMessage(initDataForVideocall, "*");
        }
    };

    sendDestroyMessage = () => {
        const deinitDataForVideocall = {
            event: "destroy"
        };

        if (this.iframe) {
            document.getElementsByTagName("iframe")[0].contentWindow.postMessage(deinitDataForVideocall, "*");
        }
    };

    sendFocusRegained = () => {
        const focusRegainedData = {
            event: "refocused"
        };


        if (this.iframe) {
            document.getElementsByTagName("iframe")[0].contentWindow.postMessage(focusRegainedData, "*");
        }

        window.removeEventListener('focus', this.sendFocusRegained);
    };


    async iframeMessageListener(ev) {

        if (ev && ev.data && ev.data.type === 'REQUEST_SCREEN_SHARE_STOP') {
            this.stopScreenshare();
            return;
        }

        if (ev && ev.data && ev.data.type === 'REQUEST_SCREEN_SHARE') {
            try {
                const meetingId = ev.data.meetingId;
                const bundle = await fetchContentShareBundle(meetingId,this.context.state.selectedCompany);
                const deeplink = buildStartDeeplink(bundle);
                this.setState({ pendingIntent: deeplink, isScreenSharing: true });
                this.tryOpenDeeplink(deeplink);
            } catch (err) {
                console.error('[HOST] No se pudo iniciar content-share:', err);
            }
            return;
        }

        if (ev.data === "focusVideoCall") {
            this.focusVideocall = true;
        }
        if (ev.data === "userLeft") this.number++
        if (this.number % 2 === 1 && ev.data === "userLeft" && this.context.state.actualTurnStatus !== "VIDEOCALL_END") {
            console.log("User left tab");
            this.props.userLeftTab();
        }
        console.debug("Got message from videocall iframe", ev.data);
        if (ev.data === "incomingCall" || ev.data === "callStarted") {
            if (this.context.state.actualTurnStatus !== "VIDEOCALL_END") {
                this.context.actions.setTurnStatus("EMPTY");
            }
            if (this.props.onVideocallStarted) this.props.onVideocallStarted();
        } else if (ev.data === "closeModalVideoCall" || ev.data === "videocallFinished") {
            this.stopScreenshare();
            if (this.focusVideocall) {
                console.log("Videocall Focused");
                this.focusVideocall = false;
            } else {
                this.context.actions.setTurnStatus("VIDEOCALL_END");
                if (this.props.onVideocallEnded) this.props.onVideocallEnded();
                this.setState({
                    videocallEnded: true
                });
            }
        } else if (ev.data.event) {
            const {data} = ev;
            if (data.event === "cleanup") {
                console.log("Got cleanup message from videocall. Will reconnect in case it is needed");
                this.reattachTimeout = setTimeout(this.sendReattachMessage, 800, data);
                this.destroyTimeout = setTimeout(this.sendDestroyMessage, 100, data);
            } else if (data.event === "destroy") {
                clearTimeout(this.destroyTimeout);
                this.stopScreenshare();
            } else if (data.event === "answerFailed") {
                window.addEventListener('focus', this.sendFocusRegained);
            }
        }
    }

    componentDidMount() {
        clearTimeout(this._openTimer);
        this._launching = false;
        window.addEventListener('message', this.iframeMessageListener);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.iframeMessageListener);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.attentionFinished !== this.props.attentionFinished) {
            if (this.props.attentionFinished) {
                console.log("The turn has finished. Will destroy janus.");
                clearTimeout(this.reattachTimeout);
                this.sendDestroyMessage();
            }
        }
    }


    render() {
        const isIphone = navigator.userAgent.indexOf("iPhone") !== -1;

        if(this.context.state.actualTurn.videoCallUrl !== undefined && !this.context.state.actualTurn.ignoreVideocall) {
            var urlWithQueryParams = new URL(
                this.context.state.actualTurn.videoCallUrl ||
                this.context.state.actualTurn.jsonDetails.videoCallUrl
            );
            urlWithQueryParams.searchParams.set('companyName', this.context.state.selectedCompany);
            urlWithQueryParams.searchParams.set('videocallUser', 'mobile');
            this.iframe = <iframe id={"videocallIframe"}
                                  src={urlWithQueryParams.toString()}
                                  className="videocallIframe"
                                  frameBorder="0" ref={this.props.iframeRef}
                                  allow={isIphone ? "geolocation; microphone; camera; midi; encrypted-media" : "camera; microphone; display-capture; geolocation; midi; encrypted-media"}/>;
        } else {
            this.iframe = undefined;
        }
        return (
            <div className="videocallView">
                <AppConsumer>
                    {({state, actions}) => (
                        <div>

                            {
                                this.context.state.actualTurn.status !== "WAITING_TO_BE_CALLED" && this.context.state.actualTurnStatus !== "LOST_CONNECTION" &&
                                <div className="videocallContainer">
                                    {this.iframe}
                                </div>
                            }
                        </div>
                    )}
                </AppConsumer>
            </div>
        );
    }
}

Videocall.contextType = AppConsumer;
export default withTracker(Videocall);

